export default __webpack_public_path__ + "static/media/section2-7-num2.fc9bab4b.png";